export class HtmlTextFormatHelper {
  public static getText(str: string) {
    if (str.includes('xmlns')) {
      const parsedStr = new DOMParser().parseFromString(str, 'text/html').body.innerHTML;
      return parsedStr.replace(/<.*?>/g, '');
    }
    const tmp = document.createElement('DIV');
    tmp.innerHTML = str;
    return tmp.textContent || tmp.innerText || '';
  }
}
